import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createHashHistory } from 'history';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

var options = function options(accessToken, method, body, headers) {
  var opt = {
    mode: 'cors',
    method: method,
    headers: {},
    cache: 'no-cache'
  };
  var headersTobeEdited = opt.headers;

  if (accessToken) {
    headersTobeEdited.Authorization = "Bearer ".concat(accessToken);
  }

  if (body) {
    opt.body = body;
  } // Add extra headers to request if they exist


  if (headers !== null && headers !== undefined) {
    Object.keys(headers).forEach(function (key) {
      headersTobeEdited[key] = headers[key];
    });
  }

  return opt;
};

var getToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(msalInstance, scopes) {
    var account, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            account = msalInstance.getActiveAccount();

            if (account) {
              _context.next = 3;
              break;
            }

            throw Error('No active account! Verify a user has been signed in and setActiveAccount has been called.');

          case 3:
            _context.next = 5;
            return msalInstance.acquireTokenSilent({
              scopes: scopes,
              account: account
            });

          case 5:
            response = _context.sent;
            return _context.abrupt("return", response.accessToken);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getToken(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export var requestWithHeaders = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, method, body, headers) {
    var msalInstance, scopes, url, request, accessToken, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            msalInstance = _ref2.msalInstance, scopes = _ref2.scopes, url = _ref2.url;
            request = {
              scopes: scopes,
              account: msalInstance.getActiveAccount() || undefined
            };
            _context2.prev = 2;
            _context2.next = 5;
            return getToken(msalInstance, scopes);

          case 5:
            accessToken = _context2.sent;
            _context2.next = 8;
            return fetch(url, options(accessToken, method, body, headers));

          case 8:
            response = _context2.sent;

            if (!(response.status === 401)) {
              _context2.next = 12;
              break;
            }

            _context2.next = 12;
            return msalInstance.acquireTokenRedirect(request);

          case 12:
            if (response.status === 403) {
              createHashHistory().push('/forbidden');
            }

            return _context2.abrupt("return", response);

          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](2);

            if (!(_context2.t0 instanceof InteractionRequiredAuthError)) {
              _context2.next = 21;
              break;
            }

            _context2.next = 21;
            return msalInstance.acquireTokenRedirect(request);

          case 21:
            return _context2.abrupt("return", null);

          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 16]]);
  }));

  return function requestWithHeaders(_x3, _x4, _x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();
export var requestJson = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(config, method, body) {
    var headers, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            headers = {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            };
            _context3.next = 3;
            return requestWithHeaders(config, method, body, headers);

          case 3:
            response = _context3.sent;

            if (!response) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return", response.json());

          case 6:
            return _context3.abrupt("return", null);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function requestJson(_x7, _x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();